import type { MouseEvent } from 'react';

import { IconButton, CloseIcon } from '@frontend/legacy-components';

interface ToastCloseButtonProps {
  handleClose: (e: MouseEvent) => void;
}

const ToastCloseButton = ({ handleClose }: ToastCloseButtonProps) => {
  return (
    <IconButton
      size="sm"
      onClick={(e: MouseEvent) => handleClose(e)}
      position="absolute"
      top={2}
      right={2}
      padding={0.5}
    >
      <CloseIcon />
    </IconButton>
  );
};

export default ToastCloseButton;
